/**
 * ISO 639-1
 */
export enum LangEnum {
  ITALIAN = 'it',
  ENGLISH = 'en',
  GREEK = 'el'
}
